import QrGeneratedAssignedGraphCard from './qrGeneratedAssignedGraphCard.container';

export default QrGeneratedAssignedGraphCard;
